import React from 'react'
import './index.scss'

const ConfirmRemoval = (props) => {
  const { remove, cancel, type } = props

  return (
    <div className='confirm-removal-container'>
      <div className='center'>
        <p style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }}>{`Delete this ${type}`}</p>
        <p style={{ marginTop: '10px', fontWeight: 'bold', textAlign: 'center' }}>{`Delete this ${type} from your map and your saved content?`}</p>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
          <button
            onClick={cancel}
            style={{ margin: '0', width: '45%' }}>CANCEL</button>
          <button
            onClick={remove}
            style={{ margin: '0', backgroundColor: '#ff6800', width: '45%' }}>YES, DELETE</button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmRemoval